import React from 'react';
import cn from 'classnames';

import styles from './Testimonials.module.postcss';
import tripleStyles from './Triple.module.postcss';

function Testimonials({ title }) {
  return (
    <section className='Section--extraPadding'>
      <h3 className='u-phosphate u-mb2'>{ title || "Join Thousands Who've Booked Catering With Us!"}</h3>
      <div className={tripleStyles.Triple_wrapper}>

        <div className={tripleStyles.Triple}>
          <div className={cn(styles.Testimonial, styles.Testimonial__green)}>
            <img
              src='https://static.seattlefoodtruck.com/photos/Kyle_and_Caroline.jpeg'
              alt='Kyle & Caroline - Kent, WA'
              className={styles.Testimonial_Img}
              loading='lazy'
              fetchpriority='low'
            />
          </div>
          <p className='u-mt1'>With a wedding on a farm, traditional caterers weren&#39;t able to serve our party without a full kitchen on site. Booking a food truck helped us bring delicious cuisine to our beautiful night!</p>
          <h3 className='u-mt1 u-mb0'>Kyle & Caroline - Kent, WA</h3>
        </div>

        <div className={tripleStyles.Triple}>
          <div className={cn(styles.Testimonial, styles.Testimonial__pink)}>
            <img
              src='https://static.seattlefoodtruck.com/photos/Chelsea.jpeg'
              alt='Chelsea - Bellevue, WA'
              className={styles.Testimonial_Img}
              loading='lazy'
              fetchpriority='low'
            />
          </div>
          <p className='u-mt1'>We wanted to surprise our team with a food truck to thank them for their hard work. We hired an ice cream cart and they were able to set up inside our office! People still ask when we can do it again!</p>
          <h3 className='u-mt1 u-mb0'>Chelsea - Bellevue, WA</h3>
        </div>

        <div className={tripleStyles.Triple}>
          <div className={cn(styles.Testimonial, styles.Testimonial__blue)}>
            <img
              src='https://static.seattlefoodtruck.com/photos/Brett.jpeg'
              alt='Brett - Seattle, WA'
              className={styles.Testimonial_Img}
              loading='lazy'
              fetchpriority='low'
            />
          </div>
          <p className='u-mt1'>Calling caterers one by one was exhausting. We sent one request on SeattleFoodTruck.com and we had dozens of food trucks coming to us with bids and menu options.</p>
          <h3 className='u-mt1 u-mb0'>Brett - Seattle, WA</h3>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
